module.exports = __webpack_public_path__ + "img/swiper-img4.7aec6a83.png";